import React from "react";

const PanelTitle = ({ title, bold }) => {
  return (
    <p
      className="panel-title"
      style={
        bold
          ? {
              color: "#000",
              textTransform: "uppercase",
              fontWeight: "bold",
              margin: "5px 0",
            }
          : {}
      }
    >
      {title}
    </p>
  );
};

export default PanelTitle;
